// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_fw","catalogByServiceItem__title":"c-k_fx"};